var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "from",
    staticStyle: {
      "padding": "0 10%"
    },
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "楼栋",
      "prop": "ssmc"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入楼层"
    },
    model: {
      value: (_vm.from.ssmc),
      callback: function($$v) {
        _vm.$set(_vm.from, "ssmc", $$v)
      },
      expression: "from.ssmc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "楼层",
      "prop": "ssdz"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入楼层"
    },
    model: {
      value: (_vm.from.ssdz),
      callback: function($$v) {
        _vm.$set(_vm.from, "ssdz", $$v)
      },
      expression: "from.ssdz"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "房间号",
      "prop": "fzrdh"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入房间号"
    },
    model: {
      value: (_vm.from.fzrdh),
      callback: function($$v) {
        _vm.$set(_vm.from, "fzrdh", $$v)
      },
      expression: "from.fzrdh"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "30%",
      "background-color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13f85e76","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xzgl/SsfjGl/FjGl_add.vue
// module id = null
// module chunks = 